export default __webpack_public_path__ + "static/media/nav-logo--takeaway.a2a5363d.jpg";